import React, { FunctionComponent, useCallback } from 'react'
import { TicketNarrativeBar } from 'view/shared/ticket'
import { LinkButton } from 'view/components/buttons'
import { DealDetail, DealStatus, DealActions } from 'api'
import { canServicingRevertAttributes } from '../utils'
import { Translation, Locale } from 'locale'

export interface DealTicketNarrativeBarProps {
  dealDetail: DealDetail
  onRevert: typeof DealActions.servicingRevertAttributes
  isAdminAmendAndWithOtherUser: boolean
}

export const DealTicketNarrativeBar: FunctionComponent<DealTicketNarrativeBarProps> = props => {
  const { dealDetail, onRevert, isAdminAmendAndWithOtherUser } = props

  const handleRevert = useCallback(() => {
    onRevert(dealDetail.deal.dealId)
  }, [onRevert, dealDetail])

  if (canServicingRevertAttributes(dealDetail) && !isAdminAmendAndWithOtherUser) {
    return (
      <TicketNarrativeBar revertible={true}>
        {Locale.translate(Translation.SC_TICKET_MODIFIED_NARRATIVE)}
        <LinkButton onClick={handleRevert}>{Locale.translate(Translation.TC_ACTION_UNDO)}</LinkButton>
      </TicketNarrativeBar>
    )
  } else if (dealDetail.deal.status === DealStatus.CANCELLED) {
    const userId = dealDetail.deal.lastUpdatedBy
    return <TicketNarrativeBar>{Locale.translate(Translation.SC_TICKET_CANCELED_BY_USER, { userId })}</TicketNarrativeBar>
  } else {
    return null
  }
}
